module.exports = __webpack_public_path__ + "img/logo-bg.12c6b698.png";